import RelatedContent from 'components/RelatedContent/RelatedContent';

export default RelatedContent;
